import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          เครดิตฟรี <code>ล่าสุด</code>แจกไม่อั้นกดรับได้ทันที.
        </p>
        <a
          className="App-link"
          href="https://liff.line.me/1657475303-ZrW3J29d"
          target="_blank"
          rel="noopener noreferrer"
        >
          เครดิตฟรีล่าสุด
        </a>
      </header>
    </div>
  );
}

export default App;
